<template>
    <div class="home-top">
        <Header cur="Trang Chủ" />
        <div class="top-title">
            GREENSKY SOFTWARE COMPANY LIMITED Cung cấp giải pháp phần mềm tiên tiến
        </div>
    </div>
    <div class="home-about">
        <div>
            <div class="about-title">Về Chúng Tôi</div>
            <div class="about-info">
                GREENSKY là một công ty phần mềm hàng đầu, chuyên:focus vào phát triển và cung cấp các sản phẩm phần mềm
                chất lượng cao đáp ứng nhu cầu đa dạng của khách hàng.
            </div>
        </div>
        <img class="about-img" src="../assets/aboutImg.webp" alt="">

    </div>
    <div class="home-service">
        <img class="service-title" src="../assets/serviceTitle.webp" alt= />
        <div class="service-card" v-for="item in serviceLists" :key="item.index">
            <img class="item-title" :src="require('@/assets/cardTitle' + item.index + '.webp')" alt="">
            <div class="item-content">{{ item.content }}</div>
        </div>
    </div>
    <Footer />
</template>
<script setup>
import Header from "@/components/HeaderCom.vue";
import Footer from "@/components/FooterCom.vue";
const serviceLists = [
    {
        index: 1,
        title: "Phát triển phần mềm tùy chỉnh",
        content:
            "Chúng tôi chuyên thiết kế và phát triển phần mềm theo yêu cầu cụ thể của khách hàng, đảm bảo phù hợp hoàn toàn với quy trình và mục tiêu riêng của từng doanh nghiệp."
    },
    {
        index: 2,
        title: "Dịch vụ bảo trì phần mềm",
        content:
            "Cung cấp dịch vụ bảo trì và nâng cấp phần mềm, đảm bảo hệ thống phần mềm của khách hàng luôn hoạt động ổn định và cập nhật mới nhất với các tính năng và bảo mật."
    },
    {
        index: 3,
        title: "Hệ thống quản lý dữ liệu",
        content:
            "Xây dựng và quản lý hệ thống giúp khách hàng lưu trữ, xử lý và phân tích dữ liệu một cách hiệu quả, hỗ trợ đưa ra quyết định kinh doanh sáng tạo và chính xác."
    }
];
</script>
<style scoped lang="less">
.home-top {
    height: 616px;
    background-image: url("../assets/homeBg.webp");
    background-size: 100% 100%;
    background-repeat: no-repeat;
    margin-bottom: 102px;
    position: relative;

    .top-title {
        width: 1221px;
        height: 166px;
        font-weight: bold;
        font-size: 55px;
        color: #FFFFFF;
        line-height: 76px;
        text-align: center;
        position: absolute;
        top: 200px;
        left: 50%;
        transform: translateX(-50%);
    }
}

.home-service {
    margin-bottom: 210px;
    padding: 0 140px 0 91px;

    .service-title {
        width: 684px;
        height: 87px;
        object-fit: cover;
        display: block;
        margin: 0 auto 139px;
    }

    .service-card {
        width: 1209px;
        height: 179px;
        border-radius: 30px;
        border: 1px solid #000000;
        box-sizing: border-box;
        padding: 30px 11px;
        margin-bottom: 30px;

        .item-title {
            width: auto;
            height: 40px;
            object-fit: cover;
            margin-bottom: 21px;
        }

        .item-content {
            font-weight: 400;
            font-size: 21px;
            color: #000000;
            line-height: 29px;
        }
    }
}

.home-about {
    padding: 0 140px 0 101px;
    margin-bottom: 136px;
    display: flex;
    align-items: center;

    .about-title {
        font-weight: bold;
        font-size: 62px;
        color: #000000;
        line-height: 84px;
        text-align: center;
        margin-bottom: 39px;
    }

    .about-info {
        font-weight: 400;
        font-size: 31px;
        color: #000000;
        line-height: 44px;
    }

    .about-img {
        margin-left: 89px;
        width: 557px;
        height: 516px;
        object-fit: cover;
    }
}
</style>